import React from "react";
// @ts-expect-error - this will be resolved at build time
import { Box } from "@xsolla/xui-primitives";
import { Tag } from "@xsolla/xui-tag";
import type { CalendarChipsProps } from "./types";

export const CalendarChips: React.FC<CalendarChipsProps> = ({
  chips,
  activeChip,
  onChipSelect,
  testID,
  themeMode,
  themeProductContext,
}) => {
  if (!chips || chips.length === 0) return null;

  return (
    <Box
      testID={testID}
      flexDirection="row"
      flexWrap="wrap"
      gap={8}
      marginBottom={16}
    >
      {chips.map((chip) => {
        const isActive = activeChip === chip.value;
        return (
          <Box
            key={chip.value}
            onPress={() => onChipSelect?.(chip.value)}
            cursor="pointer"
          >
            <Tag
              size="sm"
              tone={isActive ? "brand" : "primary"}
              type={isActive ? "solid" : "outlined"}
              themeMode={themeMode}
              themeProductContext={themeProductContext}
            >
              {chip.label}
            </Tag>
          </Box>
        );
      })}
    </Box>
  );
};
